import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    refresh: false,
};

const refreshSlice = createSlice({
    name: 'refresh',
    initialState,
    reducers: {
        setRefresh: (state, action) => {
            return { ...state, ...action.payload };
        },
    },
});

export const { setRefresh } = refreshSlice.actions;
export const refreshReducer = refreshSlice.reducer;
